@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.banners
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.router.EndPoint

object UpsertBannerEndpoint : EndPoint<UpsertBannerEndpoint.Request, UpsertBannerEndpoint.Response>() {
    class Request(
        val id: KmmLong?,
        val title: String,
        val description: String,
        val backgroundUrl: String?,
        val isActive: Boolean,
    )

    class Response
}